export const listStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },

  textFieldContainer: {
    display: "flex",
    alignItems: "center"
  },
  textFieldStyle: {
    paddingLeft: "5%",
    width: "100%"
  }
};

export const viewStyle = {
  textFieldStyle: {
    textTransform: "capitalize"
  }
};



// WEBPACK FOOTER //
// ./src/containers/CRM/Devices/style.js